import { addDays } from 'date-fns';
import { Box, Text } from '~/commonComponents';
import { CalendarPicker } from '~/components/shared/forms';
import { TipBanner } from '~/components/shared/TipBanner';
import { SectionCard } from '~/components/ShiftRequestRedesign/common';
import { SelectedDatesList } from './SelectedDatesList';

interface IDatesCardProps {
  selectedDates: Date[];
  onCalendarSelect: (dates: Date[] | undefined) => void;
  onRemoveDate: (date: Date) => void;
  /** Applies error highlight to the calendar when true */
  hasError?: boolean;
  /** Controls visibility of the multi-day tip banner */
  tipVisible?: boolean;
}

export const DatesCard = ({
  selectedDates,
  onCalendarSelect,
  onRemoveDate,
  hasError,
  tipVisible = false,
}: IDatesCardProps) => {
  const today = new Date();

  return (
    <SectionCard title="Dates" testId="dates-card">
      <Text fontSize={16} fontWeight={400} color="neutral_500">
        Shifts can be posted up to 99 days in advance. Use the calendars to select your dates.
      </Text>

      <Box marginTop={12}>
        <TipBanner
          visible={tipVisible}
          description="You can post for more than one day! Save time by creating multiple shifts at once."
        />
      </Box>

      <Box marginTop={14} alignItems="center">
        <CalendarPicker
          data-testid="dates-calendar"
          data-cy="dates-calendar"
          mode="multiple"
          numberOfMonths={2}
          selected={selectedDates}
          onSelect={onCalendarSelect}
          startMonth={today}
          disabled={[
            {
              before: today,
              after: addDays(today, 99),
            },
          ]}
          hasError={hasError}
        />
      </Box>

      <Box marginTop={20}>
        <SelectedDatesList dates={selectedDates} onRemoveDate={onRemoveDate} />
      </Box>
    </SectionCard>
  );
};
